import { IconButton, Tooltip } from '@commenda/kakashi';
import { cn } from '@commenda/utils';
import { SVGProps } from 'react';

export const DataPointButton = ({
  onClick,
  tooltip,
  icon,
  _className = '',
}: {
  onClick: () => void;
  tooltip: string;
  icon: (props: SVGProps<SVGSVGElement>) => React.JSX.Element;
  _className?: string;
}) => {
  const Icon = icon;

  return (
    <div className={cn('flex', _className)}>
      <Tooltip content={tooltip} side="bottom" asChild>
        <IconButton
          icon={
            <Icon className="text-text-quaternary group-hover:text-fg-brand" />
          }
          size="sm"
          aria-label={tooltip}
          onClick={onClick}
        />
      </Tooltip>
    </div>
  );
};
